// extracted by mini-css-extract-plugin
export default {"inputField":"frontend-common-libs-src-scss-auth-module__inputField--hbDmMWcRrMauMN3I9X3lHA=="};